import React from 'react';



type Props = {
  className?: string;
}
export const ProfileVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' d = 'M10 5.25C10.9625 5.25 11.75 6.0375 11.75 7C11.75 7.9625 10.9625 8.75 10 8.75C9.0375 8.75 8.25 7.9625 8.25 7C8.25 6.0375 9.0375 5.25 10 5.25ZM10 14C12.3625 14 15.075 15.1287 15.25 15.75H4.75C4.95125 15.12 7.64625 14 10 14ZM10 3.5C8.06625 3.5 6.5 5.06625 6.5 7C6.5 8.93375 8.06625 10.5 10 10.5C11.9338 10.5 13.5 8.93375 13.5 7C13.5 5.06625 11.9338 3.5 10 3.5ZM10 12.25C7.66375 12.25 3 13.4225 3 15.75V17.5H17V15.75C17 13.4225 12.3363 12.25 10 12.25Z' />
    </svg>
  );
};
